import { useQuery } from '@apollo/client';
import { HuddleStatus } from 'lib/generated/graphql';
import { GET_RECOMMENDED_HUDDLES } from 'lib/queries';
import React, { useRef, useState } from 'react';
import UpdateUser from 'src/screens/user/components/UpdateUser';
import useAuth from 'src/shared-components/Auth';
import HuddleCard from 'src/shared-components/HuddleCard/Huddle';
import Modal from 'src/shared-components/Modal';

const RecommendedProjects = () => {
  const { data: recommendedProjects } = useQuery(GET_RECOMMENDED_HUDDLES, { fetchPolicy: 'network-only' });

  // filter projects to exclude user opted in, non team-forming, and limit to 3
  const filteredRecommendedProjects = recommendedProjects?.recommender
    ?.filter(project => !project.hasUserOptedin && project.status === HuddleStatus.TeamForming)
    .slice(0, 3);

  const openModal = (section: string) => {
    setCurrentUpdateSection(section);
    modalUpdateRef.current.open();
  };
  const { user } = useAuth();
  const modalUpdateRef = useRef<any>();
  const [currentUpdateSection, setCurrentUpdateSection] = useState<string>('');
  return (
    <>
      <div className="text-[17px] font-bold mb-4 mt-12">
        New huddles you may be into ⚡️ (based on your{' '}
        <a className="text-decoration-line: underline cursor-pointer" onClick={() => openModal('tags')}>
          builder tags
        </a>
        ):
      </div>
      <div className="border-l-2 border-black pl-4">
        {filteredRecommendedProjects?.map(huddle => {
          return <HuddleCard key={huddle.id} huddle={huddle} suggestion className="mb-5" />;
        })}
      </div>
      <Modal closeOnBackdropClick={false} ref={modalUpdateRef} showCloseButton>
        <UpdateUser
          user={user}
          section={currentUpdateSection}
          onUserUpdated={() => {
            modalUpdateRef.current.close();
          }}
        />
      </Modal>
    </>
  );
};

export default RecommendedProjects;
